import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { SideNavItem } from 'teacher-ui-client/components/side-nav/item'
import { SideNavIconComponent } from 'teacher-ui-client/components/side-nav/icon'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'
import { t } from 'ember-intl'

export class RecentWritingLink extends Component {
  @service sideNav!: SideNavService

  get uiScopeModels() {
    return this.sideNav.uiScopeModels ?? []
  }

  <template>
    <SideNavItem
      @linkTo="reporting.ui-scope.writing-legends.recent-writing"
      @linkToModels={{this.uiScopeModels}}
      {{posthogEvent "Reporting" product="writing-legends" page="quizzes-completed"}}
    >
      <SideNavIconComponent @phosphorIcon="phosphor-pen-nib-fill" />
      {{t "sideNav.writing.recentWriting"}}
    </SideNavItem>
  </template>
}

export default RecentWritingLink
